import React from 'react'
import { getIn } from 'formik'

type TextFieldProps = {
  fieldTitle: React.ReactNode
  fieldType?: any
  fieldTitleAfter?: any
  filedTitleMandatory: boolean
  fieldName: string
  placeHolder?: string
  maxLength?: any
  fieldValue?: any
  disabled?: boolean
  handleOnChange?: any
  formik?: any
  className?: string
  outerdivClassName?: string
}

const TextField = ({
  fieldTitle,
  fieldTitleAfter,
  fieldType,
  filedTitleMandatory,
  fieldName,
  placeHolder,
  maxLength,
  fieldValue,
  disabled,
  handleOnChange,
  formik,
  className,
  outerdivClassName,
}: TextFieldProps) => {
  return (
    <div className={outerdivClassName}>
      <label htmlFor={fieldName} className='d-flex align-items-center mb-2'>
        <span className='fs-6 fw-semibold lh-23px'>
          {fieldTitle} {fieldTitleAfter && <span className="large-box"></span>} {fieldTitleAfter}
          {filedTitleMandatory && <span className='h5 text-danger'>*</span>}
        </span>
      </label>
      <input
        type={fieldType ? fieldType : 'text'}
        className={`form-control form-control-lg form-control-solid mb-2 ${className}`}
        id={fieldName}
        name={fieldTitle}
        data-testid={fieldName}
        placeholder={placeHolder}
        // value={fieldValue}
        maxLength={maxLength}
        {...formik?.getFieldProps(fieldName)}
        // onChange={(e: any) => handleOnChange(e, fieldName)}
        disabled={disabled}
      />
      {getIn(formik?.errors, fieldName) && getIn(formik?.touched, fieldName) && (
        <div className='fv-plugins-message-container'>
          <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
            {getIn(formik.errors, fieldName)}
          </div>
        </div>
      )}
    </div>
  )
}

export default TextField
